
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Multi field sorting" fileName="multi-sort.md" />
        <demo-block>
        <div><p>1、Enable multi field sorting by <code>multipleSort=true</code><br>2、The priority of the sort field needs to be specified by yourself,This is just an example,The specific logic is implemented by itself (generally returned by the back-end service)</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; :sort-option=&quot;sortOption&quot; border-y /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                sortOption: {
                    multipleSort: true,
                    sortChange: (params) =&gt; {
                        console.log(&quot;sortChange::&quot;, params);
                        this.sortChange(params);
                    },
                },
                columns: [
                    { field: &quot;name&quot;, key: &quot;a&quot;, title: &quot;Name&quot;, align: &quot;left&quot; },
                    {
                        field: &quot;age&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Age&quot;,
                        align: &quot;center&quot;,
                        sortBy: &quot;&quot;,
                    },
                    {
                        field: &quot;weight&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Weight(kg)&quot;,
                        align: &quot;center&quot;,
                        sortBy: &quot;asc&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;center&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;e&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        age: 25,
                        weight: 66,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        age: 20,
                        weight: 70,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        age: 18,
                        weight: 65,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        age: 17,
                        weight: 80,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        age: 26,
                        weight: 72,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
        methods: {
            sortChange(params) {
                let data = this.tableData.slice(0);

                data.sort((a, b) =&gt; {
                    if (params.age) {
                        if (params.age === &quot;asc&quot;) {
                            return a.age - b.age;
                        } else if (params.age === &quot;desc&quot;) {
                            return b.age - a.age;
                        } else {
                            return 0;
                        }
                    }
                });

                data.sort((a, b) =&gt; {
                    if (params.weight) {
                        if (params.weight === &quot;asc&quot;) {
                            return a.weight - b.weight;
                        } else if (params.weight === &quot;desc&quot;) {
                            return b.weight - a.weight;
                        } else {
                            return 0;
                        }
                    }
                });

                this.tableData = data;
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"sort-option":_vm.sortOption,"border-y":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                sortOption: {
                    multipleSort: true,
                    sortChange: (params) => {
                        console.log("sortChange::", params);
                        this.sortChange(params);
                    },
                },
                columns: [
                    { field: "name", key: "a", title: "Name", align: "left" },
                    {
                        field: "age",
                        key: "b",
                        title: "Age",
                        align: "center",
                        sortBy: "",
                    },
                    {
                        field: "weight",
                        key: "c",
                        title: "Weight(kg)",
                        align: "center",
                        sortBy: "asc",
                    },
                    {
                        field: "hobby",
                        key: "d",
                        title: "Hobby",
                        align: "center",
                    },
                    {
                        field: "address",
                        key: "e",
                        title: "Address",
                        align: "left",
                    },
                ],
                tableData: [
                    {
                        name: "John",
                        age: 25,
                        weight: 66,
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        age: 20,
                        weight: 70,
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        age: 18,
                        weight: 65,
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        age: 17,
                        weight: 80,
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        age: 26,
                        weight: 72,
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
        methods: {
            sortChange(params) {
                let data = this.tableData.slice(0);

                data.sort((a, b) => {
                    if (params.age) {
                        if (params.age === "asc") {
                            return a.age - b.age;
                        } else if (params.age === "desc") {
                            return b.age - a.age;
                        } else {
                            return 0;
                        }
                    }
                });

                data.sort((a, b) => {
                    if (params.weight) {
                        if (params.weight === "asc") {
                            return a.weight - b.weight;
                        } else if (params.weight === "desc") {
                            return b.weight - a.weight;
                        } else {
                            return 0;
                        }
                    }
                });

                this.tableData = data;
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  